import * as React from "react";
import numeral from "numeral";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Alert, Col, Row } from "components/bootstrap";
import { RelativeTime, Text, Title } from "components/common";
import NumberUtils from "util/NumberUtils";
import useClusterDataLakeJournalMetrics from "../hooks/useClusterDataLakeJournalMetrics";
const Description = styled(Text)(
  ({ theme }) => css`
    color: ${theme.colors.gray[50]};
  `
);
const DataLakeJournalSection = () => {
  const { t } = useTranslation("enterprise_data_lake");
  const metrics = useClusterDataLakeJournalMetrics();
  if (metrics.isLoading) {
    return null;
  }
  const hasData = metrics.size > 0 || metrics.sizeLimit > 0 || metrics.segments > 0;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Title, { order: 2 }, t("journal.title")), /* @__PURE__ */ React.createElement(Description, null, t("journal.description")), !hasData ? /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("journal.metrics_unavailable")) : /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement("dl", { className: "system-journal" }, /* @__PURE__ */ React.createElement("dt", null, t("journal.size")), /* @__PURE__ */ React.createElement("dd", null, NumberUtils.formatBytes(metrics.size)), /* @__PURE__ */ React.createElement("dt", null, t("journal.maximum_size")), /* @__PURE__ */ React.createElement("dd", null, NumberUtils.formatBytes(metrics.sizeLimit)), metrics.oldestSegment !== void 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, t("journal.earliest_entry")), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: metrics.oldestSegment }))))), /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "journal.uncommitted_summary",
      values: { uncommitted: numeral(metrics.messageUncommitted).format("0,0"), segments: metrics.segments },
      components: { bold: /* @__PURE__ */ React.createElement("strong", null) }
    }
  ), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "journal.unflushed_summary",
      values: { unflushed: numeral(metrics.unflushedMessages).format("0,0") },
      components: { bold: /* @__PURE__ */ React.createElement("strong", null) }
    }
  ))));
};
export default DataLakeJournalSection;
